import React from 'react'
import './styles.scss'
import { Button, Input, Select } from 'antd'
import classnames from 'classnames'
import CloudFlyerAPI from '../../../api/CloudFlyerAPI'

let validate = field => field !== undefined && field.length === 0

export default class AddGoogleSteps extends React.Component {
    constructor(props) {
        super(props)
        this.state = { id: null }
    }

    handleSave = id => {
        const { receiveId } = this.props
        receiveId(id)
    }

    
    startSaving = () => {}

    render() {
        const {
            disabled,
            edit,
            setupForm,
            loading,
            storages,
            billing_bucket,
            on_save,
            on_input_change,
            on_billing_bucket_change,
        } = this.props

        const {TextArea} = Input

        const { saving } = this.state

        return (
            <div className={'add-aws'}>
                <h3>On-board existing account</h3>
                <div className="input-area">
                    <div>
                        <label>Service Accounts Key(JSON)*</label>
                        <TextArea
                            rows={5}
                            placeholder="Service Accounts Key"
                            name="credentials_data"
                            value={setupForm.credentials_data}
                            disabled={edit}
                            className={classnames({required: validate(setupForm.credentials_data),})}
                            onChange={on_input_change}
                        />
                        {validate(setupForm.credentials_data) && (
                            <span className="required">Service Accounts Key is required.</span>
                        )}
                    </div>

                    <div>
                        <label>Give it a name*</label>
                        <Input
                            placeholder="Enter Account Name"
                            name="project_name"
                            value={setupForm.project_name}
                            className={classnames({
                                required: validate(setupForm.project_name),
                            })}
                            onChange={on_input_change}
                        />
                        {validate(setupForm.project_name) && (
                            <span className="required">
                                It's always good to give a name to your cloud
                                service, so you can organize them better.
                            </span>
                        )}
                    </div>
                </div>

                <div className="footer">
                    <Button
                        type="primary"
                        disabled={disabled}
                        loading={loading}
                        onClick={() => {on_save(this.handleSave)}}>
                        Apply
                    </Button>
                </div>
            </div>
        )
    }
}
